import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-wizard-header',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="wizard-header">
      <h2>{{ title }}</h2>
      <p class="wizard-explainer">{{ explanation }}</p>
    </div>
  `,
  styleUrls: ['./wizard-header.component.scss']
})
export class WizardHeaderComponent {
  @Input() title: string = '';
  @Input() explanation: string = '';
} 